module.exports = __webpack_public_path__ + "static/media/ID.fe94f38f.svg";